import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

import { reformatLot, getComposedName } from '../../../selectors/lots'

const initial = {
  lots: {},
  fixedpricelots: {},
  bids: [],
  totalSum: {}
}

const stateActions = generateActions('profile/state/GET')
const historyActions = generateActions('profile/history/GET')
const requestMeetActions = generateActions('profile/state/REQUEST_MEET')

export const getState = createAction(
  API_CONST,
  () => ({
    actions: stateActions,
    url: 'auth/info/currentState'
  })
)

export const getBidHistory = createAction(
  API_CONST,
  () => ({
    actions: historyActions,
    url: 'auth/info/lots/bids'
  })
)

export const requestMeet = createAction(
  API_CONST,
  lotId => ({
    method: 'POST',
    actions: requestMeetActions,
    url: `/auth/info/lots/${lotId}/requestVisit`
  }),
  lotId => ({ lotId })
)

export const clear = createAction('profile/CLEAR')

const reformatPersons = (items = []) => items.map(item => ({
  _id: item.lot._id,
  name: getComposedName(item.lot.persons),
  targetId: item.lot._id,
  date: item.created,
  sum: item.value,
  currency: item.currency.symbol
}))

export const paidIsDone = createAction('profile/paid/REMOVE', lotId => ({ lotId }))

export default handleActions({
  [clear]: () => ({ ...initial }),
  [historyActions[0]]: state => ({ ...state, bids: [] }),
  [historyActions[1]]: (state, { payload = [] }) => ({ ...state, bids: reformatPersons(payload || []) }),
  [stateActions[1]]: (state, { payload = {} }) => ({
    ...state,
    totalSum: payload.totalSum,
    lots: {
      win: (payload.winLots || []).map(el => reformatLot(el)),
      paid: (payload.paidLots || []).map(el => reformatLot(el)),
      active: (payload.activeLots || []).map(el => reformatLot(el)),
      visited: (payload.visitedLots || []).map(el => reformatLot(el)),
      requested: (payload.requestedLots || []).map(el => reformatLot(el))
    },
	fixedpricelots: (payload.fixedpricelots || []).map(el => reformatLot(el)),
  }),
  [paidIsDone]: (state, { payload }) => ({
    ...state,
    lots: {
      ...state.lots,
      visited: [ ...(state.lots.visited || []).filter(el => el._id !== payload.lotId) ]
    }
  }),
  [requestMeetActions[1]]: (state, { meta }) => {
    const { lotId } = meta
    let { paid = [], requested = [] } = state.lots

    const lot = paid.filter(el => el._id === lotId).shift()
    if (lot) {
      paid = paid.filter(el => el._id !== lotId)
      requested.unshift(lot)
    }

    return {
      ...state,
      lots: { ...state.lots, paid, requested }
    }
  }
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/profile/info.js